<template>
  <div>
    <slot :open-chat="open" />
  </div>
</template>

<script>
export default {
  methods: {
    open() {
      window.openTrengoChat();
    },
  }
}
</script>